<template>
    <div>
        <ul class="overview-list">
            <OverviewListItem
                :vehicle="vehicle"
                :field="depositFieldKey"
                :tooltip-text="
                    $t('pages.vehicle.deposit_footnote', {
                        feePercentage: formattedPercentage(vehicle.extraChargesServiceFeePercentage),
                    })
                "
            />
            <li v-if="isOmocomInsurance && deductibleValues" class="overview-list-item">
                <label class="overview-list-item__label">{{ $t('vehicle_fields.deductible_label') }}</label>
                <span class="overview-list-item__value">
                    {{
                        $t('pages.vehicle.deductible_value', {
                            minDeductible: deductibleValues.minDeductible,
                            maxDeductible: deductibleValues.maxDeductible,
                        })
                    }}
                    <svg-icon v-tooltip="$t('pages.vehicle.deductible_tooltip')" name="info-outline" />
                </span>
            </li>
            <OverviewListItem :vehicle="vehicle" field="cleaningFee" />
            <li v-if="additionalDriverAddon && $te('pricing.additional_drivers')" class="overview-list-item">
                <label class="overview-list-item__label">{{ $t('pricing.additional_drivers') }}</label>
                <span class="overview-list-item__value">
                    {{
                        $t('pricing.price_per_day', {
                            price: formattedPrice(
                                additionalDriverAddon.price,
                                vehicle.currency,
                                ['eur', 'chf'].includes($store.getters.defaultCurrency) ? 1 : 0
                            ),
                        })
                    }}
                </span>
            </li>
            <template v-if="vehicle.includedDistance === -1">
                <OverviewListItem
                    :vehicle="vehicle"
                    field="includedDistance"
                    :field-value="$t('pages.vehicle.included_distance_unlimited_value')"
                />
            </template>
            <template v-else>
                <div v-if="vehicle.pricing && vehicle.pricing.numberOfNights">
                    <OverviewListItem
                        :vehicle="vehicle"
                        field="includedDistance"
                        :field-value="
                            $t('pages.vehicle.included_distance_calculated', {
                                includedDistanceMiles: $options.filters.rounded(
                                    (vehicle.includedDistance * vehicle.pricing.numberOfNights) / 10
                                ),
                                includedDistanceKm: $options.filters.rounded(
                                    vehicle.includedDistance * vehicle.pricing.numberOfNights
                                ),
                            })
                        "
                    />
                </div>
                <template v-else>
                    <OverviewListItem
                        :vehicle="vehicle"
                        field="includedDistance"
                        :tooltip-text="
                            $t('pages.vehicle.included_distance_footnote', {
                                distanceMiles: exampleIncludedDistanceMiles,
                                distanceKm: exampleIncludedDistanceKm,
                            })
                        "
                    />
                </template>
                <OverviewListItem :vehicle="vehicle" field="pricePerKilometerIncFee" />
            </template>
        </ul>
    </div>
</template>

<script>
import OverviewListItem from '~/components/vehicle/OverviewListItem.vue';
import { ADDITIONAL_DRIVER } from '~/config/productTypes';

export default {
    components: {
        OverviewListItem,
    },
    props: {
        vehicle: {
            type: Object,
            default: () => {},
        },
        deductibleValues: {
            type: Object,
            default: () => {},
        },
        addons: {
            type: Array,
            default: null,
        },
        isOmocomInsurance: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        depositFieldKey() {
            if (this.vehicle?.pricing?.cashDeposit) {
                return 'cashDeposit';
            }

            return 'deposit';
        },
        exampleIncludedDistanceMiles() {
            return this.$root.$options.filters.rounded((this.vehicle.includedDistance * 4) / 10, 1);
        },
        exampleIncludedDistanceKm() {
            return this.$root.$options.filters.rounded(this.vehicle.includedDistance * 4);
        },
        additionalDriverAddon() {
            return this.addons?.find(p => p.type === ADDITIONAL_DRIVER);
        },
    },
};
</script>
